import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { fontSizeAtom } from '@frontend/atoms/appearanceAtom';

export function useFontSize() {
  const fontSize = useAtomValue(fontSizeAtom);

  useEffect(() => {
    const root = document.documentElement;

    if (fontSize === 'comfort') {
      root.style.setProperty('--opal-chat-line-height', '1.75rem');
      root.style.setProperty('--opal-chat-font-size', '1rem');
    } else {
      root.style.setProperty('--opal-chat-line-height', '1.5rem');
      root.style.setProperty('--opal-chat-font-size', '0.875rem');
    }
  }, [fontSize]);
}
